export default "__VITE_ASSET__CDcNXxRt__"